import useSidebarByUser from "@/hooks/data/useSidebarByUser";
import { createContext } from "react"

export interface ISidebarContext extends ReturnType<typeof useSidebarByUser> {
}

export const SidebarContext = createContext<ISidebarContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default SidebarContext;